import { render, staticRenderFns } from "./SecurityIncidents.vue?vue&type=template&id=f909eb5e&"
import script from "./SecurityIncidents.vue?vue&type=script&lang=js&"
export * from "./SecurityIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports